export default __webpack_public_path__ + "static/media/avatar_poster_edit.49fbe025.jpg";